import React, { useState } from "react";
import UserContext from "./UserContext";

const UserState = (props) => {
  let initialVal={
    name: "",
    email: "",
    date: "",
  };
  const [userDetails, setUserDetails] = useState(initialVal);
  const [loggedIn, setLoggedIn] = useState(false);


  const apiCall=async()=>{
    const jwtoken = localStorage.getItem("auth-token");
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}auth/getuserdata`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application.json",
              "auth-token": jwtoken
            },
          }
        );

        const data = await response.json();
        return data;
  }

  const updateCurrentUser = async () => {
    const authToken=localStorage.getItem("auth-token");
    if (authToken.length) {
      setLoggedIn(()=>true);
    }
    // console.log("is logged in ",loggedIn);
    const data=await apiCall();
    // console.log(data.response)
    setUserDetails(data.response);
  };
  return (
    <UserContext.Provider value={{ userDetails,loggedIn, setUserDetails, updateCurrentUser,setLoggedIn}}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserState;
